import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { apiFetch } from '../../utils/apiInterceptor';
import { API_BASE_URL } from '../../utils/paths';
import { deleteSpot } from './savedSpotsSlice';

// spots/all/forecast
export const fetchSavedSpotsDailyForecast = createAsyncThunk(
  'forecast/fetchSavedSpotsDailyForecast',
  async (_, { rejectWithValue }) => {
    try {
      const response = await apiFetch(`${API_BASE_URL}/spots/all/forecast`, {
        method: 'GET',
      });

      const data = await response.json();

      if (!response.ok) {
        return rejectWithValue(data);
      }

      return data;
    } catch (error) {
      return rejectWithValue({ message: error.message });
    }
  }
);

const daylyForecastSlice = createSlice({
    name: 'dailyForecast',
    initialState: {
        spots: {},
        isLoading: false,
        errors: null,
        visibleUnitsDaily: {
          overall_rating_score: true,
          wave_height_max: true,
          wave_direction_dominant: false,
          wave_period_max: false,
          wind_speed_10m_max: false,
          wind_direction_10m_dominant: false
        }
    },
    reducers: {
      setVisibleUnitsDaily: (state, action) => {
        state.visibleUnitsDaily = action.payload;
      },
      removeSpotForecast: (state, action) => {
        delete state.spots[action.payload];
      },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchSavedSpotsDailyForecast.pending, (state) => {
                state.isLoading = true;
                state.errors = null;
            })
            .addCase(fetchSavedSpotsDailyForecast.fulfilled, (state, action) => {
                state.isLoading = false;
                state.spots = action.payload;
            })
            .addCase(fetchSavedSpotsDailyForecast.rejected, (state, action) => {
                state.isLoading = false;
                state.errors = action.payload || { message: 'Failed to fetch all spots forecast' };
            })
            // Listen to spot deletion from savedSpotsSlice
            .addCase(deleteSpot.fulfilled, (state, action) => {
                delete state.spots[action.payload];
            });
    }
});

export const { setVisibleUnits, removeSpotForecast } = daylyForecastSlice.actions;
export default daylyForecastSlice.reducer